import K_HTML from "../templates/K_HTML";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface HTMLOptions extends ComponentOptions {
    HTML: string;
}

export class HTML extends TemplateComponent {

    options: HTMLOptions;

    constructor(options: HTMLOptions) {
        super(K_HTML, options);
    }

    preRender() {
        const options = this.options;

        if (options.zScreen && options.zScreen.id) {
            options.HTML = fixHTML(options.HTML, options.zScreen.id);
        }
    }

}

function fixHTML(html, id) {
    return html.replace(new RegExp("(id=)'(.+?)'", "ig"), "$1'" + id + "_\$2'");
}
